import { capitalize, generateUtilityClass, unstable_composeClasses } from "@mui/material";
import { toolbarButtonName } from "../classes.js";
function getUtilityClass(slot) {
  return generateUtilityClass(toolbarButtonName, slot);
}
function useUtilityClasses(ownerState) {
  const { classes, showLabel, hoverBulge, indicator, selected: isActive } = ownerState;
  const labelState = capitalize(showLabel ? "on" : "off");
  const slots = {
    badge: ["badge"],
    icon: ["icon"],
    label: ["label"],
    root: ["root", `label${labelState}`, indicator && "indicator", isActive && "selected", hoverBulge && "hoverBulge"],
    tooltip: ["tooltip"]
  };
  return unstable_composeClasses(slots, getUtilityClass, classes);
}
export {
  useUtilityClasses
};
//# sourceMappingURL=useUtilityClasses.js.map
